import { useCallback } from 'react';
import { Application, useHasRedirectionLinks, useShortUrl } from '@app/api';
import { useNavigate } from 'react-router-dom';

interface Options {
  showAddToPanelInfo?: boolean;
}

export const useAppliedRedirection = (sessionLink?: string) => {
  const shortUrl = useShortUrl();
  const navigate = useNavigate();

  const { data: hasRedirectionLink } = useHasRedirectionLinks(sessionLink);
  return useCallback(
    (application: Application, options: Options = {}) => {
      if (hasRedirectionLink?.application || !hasRedirectionLink) {
        // @ts-ignore
        window.location = `${shortUrl}/applications/${
          application.id
        }/applied-redirection?${
          options.showAddToPanelInfo ? 'panel=true' : 'panel=false'
        }`;
      } else {
        navigate(`/p/${application.trackingId}`);
      }
    },
    [hasRedirectionLink],
  );
};
